type OtpDuration = {
	uuid: string;
	label: string;
	value: string;
};

export const otpDurations: OtpDuration[] = [
	{
		uuid: "9fbe044c-3bc7-427a-bf42-2f7dc9f557c4",
		label: "5 Minutes",
		value: "5",
	},
	{
		uuid: "9fbe044c-3bd1-42ae-9c49-0890cd6a584c",
		label: "10 Minutes",
		value: "10",
	},
	{
		uuid: "9fbe044c-3bd3-47e5-bdf2-a17c9467cd80",
		label: "15 Minutes",
		value: "15",
	},
	{
		uuid: "9fbe044c-3bd5-4f9b-902e-dc14e6c6ba5f",
		label: "30 Minutes",
		value: "30",
	},
];
